// Thought of the day — one quote per calendar day, same for the whole team.
export const QUOTES = [
  { text: "The best way to predict the future is to invent it.", author: "Alan Kay" },
  { text: "Quality is not an act, it is a habit.", author: "Aristotle" },
  { text: "Simplicity is the ultimate sophistication.", author: "Leonardo da Vinci" },
  { text: "Make it work, make it right, make it fast.", author: "Kent Beck" },
  { text: "The details are not the details. They make the design.", author: "Charles Eames" },
  { text: "Done is better than perfect.", author: "Sheryl Sandberg" },
  { text: "Stay hungry, stay foolish.", author: "Steve Jobs" },
  { text: "Programs must be written for people to read.", author: "Harold Abelson" },
  { text: "First, solve the problem. Then, write the code.", author: "John Johnson" },
  { text: "Great things are done by a series of small things brought together.", author: "Vincent van Gogh" },
  { text: "The way to get started is to quit talking and begin doing.", author: "Walt Disney" },
  { text: "Whether you think you can or you think you can't, you're right.", author: "Henry Ford" },
  { text: "Success is the sum of small efforts, repeated day in and day out.", author: "Robert Collier" },
  { text: "It always seems impossible until it's done.", author: "Nelson Mandela" },
  { text: "Do the best you can until you know better. Then do better.", author: "Maya Angelou" },
  { text: "Well begun is half done.", author: "Aristotle" },
  { text: "A satisfied customer is the best business strategy of all.", author: "Michael LeBoeuf" },
  { text: "Your most unhappy customers are your greatest source of learning.", author: "Bill Gates" },
  { text: "Amateurs sit and wait for inspiration. The rest of us get up and go to work.", author: "Stephen King" },
  { text: "The secret of getting ahead is getting started.", author: "Mark Twain" },
  { text: "If you're offered a seat on a rocket ship, don't ask what seat.", author: "Sheryl Sandberg" },
  { text: "Talent wins games, but teamwork wins championships.", author: "Michael Jordan" },
  { text: "Alone we can do so little; together we can do so much.", author: "Helen Keller" },
  { text: "Perfection is achieved when there is nothing left to take away.", author: "Antoine de Saint-Exupéry" },
  { text: "Every accomplishment starts with the decision to try.", author: "John F. Kennedy" },
  { text: "Energy and persistence conquer all things.", author: "Benjamin Franklin" },
  { text: "The harder I work, the luckier I get.", author: "Samuel Goldwyn" },
  { text: "Focus on being productive instead of busy.", author: "Tim Ferriss" },
  { text: "What we fear doing most is usually what we most need to do.", author: "Tim Ferriss" },
  { text: "Move fast with stable infrastructure.", author: "Mark Zuckerberg" },
  { text: "Design is not just what it looks like. Design is how it works.", author: "Steve Jobs" },
  { text: "Code is like humor. When you have to explain it, it's bad.", author: "Cory House" },
  { text: "Continuous improvement is better than delayed perfection.", author: "Mark Twain" },
  { text: "Fall seven times, stand up eight.", author: "Japanese proverb" },
  { text: "A river cuts through rock not because of its power, but its persistence.", author: "Jim Watkins" },
  { text: "Dream big. Start small. Act now.", author: "Robin Sharma" },
  { text: "You don't have to be great to start, but you have to start to be great.", author: "Zig Ziglar" },
  { text: "Strive not to be a success, but rather to be of value.", author: "Albert Einstein" },
  { text: "Either you run the day or the day runs you.", author: "Jim Rohn" },
  { text: "The future depends on what you do today.", author: "Mahatma Gandhi" },
  { text: "Small daily improvements are the key to staggering long-term results.", author: "Robin Sharma" },
  { text: "Work hard in silence; let success make the noise.", author: "Frank Ocean" },
  { text: "Opportunities don't happen. You create them.", author: "Chris Grosser" },
  { text: "Believe you can and you're halfway there.", author: "Theodore Roosevelt" },
  { text: "Act as if what you do makes a difference. It does.", author: "William James" },
];

export const getThoughtOfTheDay = (date = new Date()) => {
  const start = new Date(date.getFullYear(), 0, 0);
  const dayOfYear = Math.floor((date - start) / 86400000);
  return QUOTES[dayOfYear % QUOTES.length];
};

export const getGreeting = (date = new Date()) => {
  const h = date.getHours();
  if (h < 12) return "Good morning";
  if (h < 17) return "Good afternoon";
  return "Good evening";
};
